import React from 'react'
import { withRouter } from 'react-router-dom'

export const ScrollToTop = withRouter(class ScrollToTopInner extends React.Component {
  static propTypes = {
    location: PropTypes.object,
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props
    if(location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const { children } = this.props
    return children
  }
})


export const ScrollToTopOnMount = withRouter(class ScrollToTopOnMountInner extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return null
  }
})
